import { useTheme } from "@material-ui/core";
import { green, orange, yellow } from "@material-ui/core/colors";
import { get } from "lodash";
import React from "react";
import {
	DateField,
	List as RaList,
	TextField,
	useTranslate,
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import Empty from "./Empty";
import ContentField from "./fields/ContentField";
import ViewField from "./fields/ViewField";
import Filters from "./Filters";
import ReadButton from "./ReadButton";
import ReadUnreadButton from "./ReadUnreadButton";
import UnreadButton from "./UnreadButton";

const BulkActionButtons = (props) => (
	<React.Fragment>
		<ReadButton
			label="resources.notifications.actions.sign_as_readed"
			{...props}
		/>
		<UnreadButton
			label="resources.notifications.actions.sign_as_readed"
			{...props}
		/>
	</React.Fragment>
);

const List = (props) => {
	const translate = useTranslate();
	const classes = useListStyles();
	const theme = useTheme();
	const isDark = get(theme, "palette.type", null) === "dark";
	const rowStyle = (record) => {
		if (isDark) {
			return {
				backgroundColor: record.readed ? green[100] : orange[100],
			};
		}
		return {
			backgroundColor: record.readed ? green[50] : yellow[50],
		};
	};
	return (
		<React.Fragment>
			<RaList
				{...props}
				exporter={false}
				perPage={perPage(50, 25)}
				filters={<Filters />}
				sort={{ field: "created", order: "DESC" }}
				classes={classes}
				empty={<Empty />}
				bulkActionButtons={<BulkActionButtons />}
				title={translate("resources.notifications.name", 0)}
				actions={<Actions />}
			>
				<ResponsiveList
					rowStyle={rowStyle}
					mobileHeader={
						<React.Fragment>
							<TextField
								source="title"
								style={{ fontWeight: "bold" }}
								variant="subtitle1"
							/>
						</React.Fragment>
					}
					mobileActions={
						<React.Fragment>
							<ReadUnreadButton source="readed" />
							<ViewField source="resource" label="" />
						</React.Fragment>
					}
					mobileBody={
						<React.Fragment>
							<DateField source="created" showTime color="textSecondary" />
							<TextField source="content" />
						</React.Fragment>
					}
				>
					<ContentField label="resources.notifications.fields.content" />
					<DateField showTime source="created" color="textSecondary" />
				</ResponsiveList>
			</RaList>
		</React.Fragment>
	);
};
export default List;
